export const MARKETING_SITE_URL_DOWNLOAD = "https://sunset.app/download";
